import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ff48641&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4ff48641&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff48641",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff48641')) {
      api.createRecord('4ff48641', component.options)
    } else {
      api.reload('4ff48641', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ff48641&scoped=true", function () {
      api.rerender('4ff48641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TdTable/index.vue"
export default component.exports